export default __webpack_public_path__ + "static/media/vitalik_nft_14.eaa4a9c8.svg";